import SavedViewController from "./saved_view_controller"

export default class extends SavedViewController {
  prepare(event) {
    if (!this.hasFiltersTarget || !this.hasParametersTarget) {
      event.preventDefault()
      return
    }
    const fields = []
    for (const [name, value] of new FormData(this.filtersTarget)) {
      if (!/^filters\[[^\]]+\]$/.test(name)) continue
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = name
      input.value = value
      fields.push(input)
    }
    this.parametersTarget.replaceChildren(...fields)
  }
}
